import { debounce } from "lodash";
import { useCallback, useEffect, useRef, useState } from "react";
import { FormProvider } from "react-hook-form";

const submitEvent = new Event("submit", { bubbles: true, cancelable: true });

const formStyle = {
  width: "100%",
};

export default function Form(props) {
  const {
    methods,
    children,
    onSubmit,
    // Chamado quando o submit é barrado pela validação. Sem ele o clique é
    // engolido em silêncio, sem nenhuma pista do que impede o save.
    // Desestruturado também para não vazar como atributo no <form>.
    onInvalid,
    submitOnChange,
    debounceDelay = 0,
    ...rest
  } = props;
  const {
    handleSubmit,
    watch,
    formState: { isDirty },
  } = methods;

  const formRef = useRef(null);
  const previousValues = useRef(methods.getValues());

  const [values, setValues] = useState();

  const dispatchSubmitEvent = useCallback(
    debounce(() => {
      formRef.current?.dispatchEvent(submitEvent);
    }, debounceDelay),
    [formRef, debounceDelay]
  );

  useEffect(() => {
    const subscription = watch((attrs) => {
      if (!submitOnChange) return;
      setValues(attrs);
    });

    return () => {
      subscription.unsubscribe();
    };
  }, [submitOnChange, watch]);

  useEffect(() => {
    if (!submitOnChange) return;

    if (
      // Prevents submitting on mount
      isDirty &&
      submitOnChange &&
      values &&
      JSON.stringify(values) !== JSON.stringify(previousValues.current)
    ) {
      previousValues.current = values;
      dispatchSubmitEvent();
    }
  }, [values, isDirty, submitOnChange, formRef, dispatchSubmitEvent]);

  useEffect(() => {
    if (!isDirty) {
      // Reset previous values when form is clean
      previousValues.current = undefined;
    }
  }, [isDirty]);

  return (
    <FormProvider {...methods}>
      {/*
        noValidate desliga a validação nativa do browser: os campos carregam o
        atributo `required` no HTML, então o browser barrava o submit antes que
        o react-hook-form fosse acionado — o clique morria sem mensagem nenhuma.
        Quem valida é o resolver (yup), que já tem as mensagens em português.
      */}
      <form
        ref={formRef}
        noValidate
        style={formStyle}
        onSubmit={handleSubmit(onSubmit, onInvalid)}
        {...rest}
      >
        {children}
      </form>
    </FormProvider>
  );
}
